/* global process */
import constants from '../../Constants';
import environmentNames from '../../environmentNames';
import questionReader from '../../../store/readHelpers/QuestionReader';
import { getMediaTargetId } from './MediaModels';
import assessmentReader from '../../../store/readHelpers/AssessmentReader';
import objectTypes from '../../../constants/ObjectTypes';

export function generatePdfUrlFromLogicalName(logicalName, assessmentRunId) {
    let url = '';

    if (process.env.NODE_ENV === environmentNames.DEVELOPMENT) {
        url = `/files/${logicalName}.pdf`;
    } else {
        url = `/file/cil/${logicalName}/pdf`;
        if (assessmentRunId) {
            url += `?assessmentRunId=${assessmentRunId}`;
        }
    }

    return url;
}

export function isPDFPanel(element) {
    return element.getAttribute('id') === 'pdfView';
}

export function parsePDFModel(pdfObject, assessmentRunId, questionIdentifier, isMainMedia = false) {
    const lang = pdfObject.getAttribute('lang');
    const logicalName = pdfObject.getAttribute(constants.contentAttributes.LOGICAL_NAME);
    const pdfSourceUrl = generatePdfUrlFromLogicalName(logicalName, assessmentRunId);
    const type = pdfObject.getAttribute('type');
    const pdfjsUrl = constants.staticLibPaths.PDFJS;
    const urlPresigned = false;
    const model = {
        isMainMedia,
        lang,
        logicalName,
        pdfSourceUrl,
        type,
        pdfjsUrl,
        urlPresigned,
    };

    if (questionIdentifier) {
        model.target = getMediaTargetId(questionIdentifier, pdfObject);
    }

    return model;
}

export function getPDFPanelModel(itemBodyElement, language, assessmentRunId, category) {
    if (category === objectTypes.CATEGORY.STIMULUS) {
        return undefined;
    }
    const defaultLanguage = itemBodyElement.getAttribute(constants.defaultLanguageAttr);
    const supportedLanguages = itemBodyElement.getAttribute(constants.supportedLanguagesAttr).split(',');
    const assessmentLanguages = assessmentReader.getSupportedLanguages();
    const langToUse = questionReader.getContentLanguageToUse(language, supportedLanguages, defaultLanguage, assessmentLanguages);
    const elements = itemBodyElement.getElementsByTagName('div');

    for (const element of Array.from(elements)) {
        if (isPDFPanel(element)) {
            for (const pdfObjectElement of Array.from(element.childNodes)) {
                if (pdfObjectElement.nodeType === 1) {
                    const pdfObjectLan = pdfObjectElement.getAttribute('lang');
                    if (pdfObjectLan === langToUse) {
                        return parsePDFModel(pdfObjectElement, assessmentRunId);
                    }
                    if (!pdfObjectLan && langToUse === defaultLanguage) {
                        return parsePDFModel(pdfObjectElement, assessmentRunId);
                    }
                }
            }
        }
    }

    return undefined;
}
